import React, { useState } from 'react';
import './PriceMobile.module.css';
import classes from './PriceMobile.module.css';
import {Grid, Button} from '@material-ui/core';

const data = [
    {
        name: "Губи",
        options: [
            {name: "Sardenya (1 ml)", cost:"4500"},
            {name: "Neuramis (1 ml)", cost:"4700"},
            {name: "Stylage M (1 ml)", cost:"6300"},
            {name: "Stylage L (1 ml)", cost:"6600"},
            {name: "Juvederm Smile (0,55 ml)", cost:"5700"},
            {name: "Juvederm 2 (0,55 ml)", cost:"5200"},
            {name: "Juvederm 3 (1 ml)", cost:"6800"},
            {name: ".", cost: '.'},
            {name: "Видалення старого філлера", cost:"2600"},
            {name: "Інфільтраційна анестезія", cost:"300"},
        ]
    },
    {
        name: "Ліполітики",
        options: [
            {name: "Зменшення носу:", cost:"."},
            {name: "Light Fit", cost:"2500"},
            {name: ".", cost: '.'},
            {name: "Обличчя:", cost:"."},
            {name: "Miore V-line", cost:"1300"},
            {name: "Metabolites+Lipotrofine", cost:"1300"},
            {name: "Light Fit", cost:"2300"},
            {name: ".", cost: '.'},
            {name: "Тіло:", cost:"."},
            {name: "Pressensa", cost:"1500"},
        ]
    },
    {
        name: "Ботулотоксин",
        options: [
            {name: "Dysport", cost:"."},
            {name: ".", cost: '.'},
            {name: "Лоб", cost:"2600/3000"},
            {name: "Очі", cost:"2600"},
            {name: "Міжбрівя", cost:"3000/3500"},
            {name: "Губи", cost:"1500"},
            {name: "Ліфтинг Ніфертіті", cost:"10500"},
            {name: "Гіпергідроз 500 OD", cost:"15000"},
            {name: ".", cost: '.'},
            {name: "Botox", cost:"."},
            {name: ".", cost: '.'},
            {name: "Лоб", cost:"2100"},
            {name: "Очі", cost:"2000"},
            {name: "Міжбрів'я", cost:"2800"},
            {name: "Губи", cost:"1500"},
            {name: "Ліфтинг Ніфертіті", cost:"7500"},
            {name: "Фулфейс (50 ОД)", cost:"6000"},
        ]
    },
    {
        name: "Контурна пластика",
        options: [
            {name: "Нососльозні борозни:", cost:"."},
            {name: "Juvederm Volbella", cost:"7900"},
            {name: ".", cost: '.'},
            {name: "Носогубні зморшки", cost:"4000"},
            {name: ".", cost: '.'},
            {name: "Скули:", cost:"."},
            {name: "Neuramis Voluma (2 ml)", cost:"7000"},
            {name: "Juvederm Volume (2 ml)", cost:"13000"},
            {name: ".", cost: '.'},
            {name: "Кути Джолі (2 ml)", cost:"7000"},
            {name: "Підборіддя", cost:"4500"},
        ]
    },
    {
        name: "Мезотерапія",
        options: [
            {name: "Мезотерапія волосся", cost:"700"},
            {name: ".", cost: '.'},
            {name: "Мезотерапія обличчя", cost:"2000"},
            {name: "Мезотерапія очі", cost:"2000"},
            {name: ".", cost: '.'},
            {name: "Aquashine Classic", cost:"4700"},
            {name: "Aquashine BR", cost:"4700"},
            {name: "Aquashine BTX", cost:"5100"},
            {name: ".", cost: '.'},
            {name: "Rejuran I", cost:"4000"},
            {name: "Rejuran Healer (1 ml)", cost:"5300"},
            {name: "Rejuran HB", cost:"4200"},
            {name: ".", cost: '.'},
            {name: "Belotero soft бланшинг", cost:"6200"},
            {name: "PRX t33", cost:"1800"},
            {name: "Мезороллер", cost:"600"},
        ]
    },
    {
        name: "Мезонитки",
        options: [
            {name: "Коги", cost:"3500"},
            {name: "Лисячі очі", cost:"5000"},
            {name: "Підтяжка брів", cost:"5000"},
            {name: "Моно нитки (10 шт)", cost:"2700"},
            {name: "Скрю, Торнадо полімолочна кислота (10 шт)", cost:"3500"},
            {name: "Нитки Скрю, Торнадо (10 шт)", cost:"3000"},
        ]
    },
];

function PriceMobile() {
    const [item, setItem] = useState(0);
    return (
        <React.Fragment>
            <div className="pricing-body">
                <div className="container">
                    <Grid container justify={'center'}>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={11}>
                            <Grid container direction="row" justify={"left"} alignContent={"center"} xs={12} spacing={1} className={classes.PriceButtons}>
                                {data.map((dataItem, index) => (
                                    <Grid item key={index}><Button variant="outlined" onClick={() => setItem(index)}>{dataItem.name}</Button></Grid>
                                ))}
                            </Grid>
                        </Grid>
                        <Grid item xs={2}>
                        </Grid>
                    </Grid>
                    <Grid container justify={'center'} alignItems={"center"} className={classes.PriceItems}>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={11}>
                            <Grid container direction={"column"} justify={"center"} alignContent={"left"} className={classes.PriceItemsList}>
                                {data[item].options.map((optItem, index) => (
                                    <Grid container  direction={"row"} justify={"space-between"} alignContent={"left"}  className={classes.PriceItemsListEntry} key={index}>
                                        {("" + optItem.name) === '.' ?
                                            <Grid item className={classes.PriceTextHidden}>{optItem.name}</Grid>
                                            : <Grid item className={classes.PriceText}>{optItem.name}</Grid>}
                                        {("" + optItem.cost) === '.' ?
                                            <Grid item className={classes.PriceTextHidden}>{optItem.cost} </Grid>
                                            : <Grid item className={classes.PriceTextAmount}>{optItem.cost} </Grid>}
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </React.Fragment>
    )
}

export default PriceMobile;
